export const homePage = () => `
  <!-- Hero Section -->
  <section class="hero">
    <div class="container">
      <h1>YILDIZ360 ile Sigortanız Güvende!</h1>
      <p class="hero-subtitle">20+ anlaşmalı sigorta şirketi ile size en uygun teklifi sunuyoruz.</p>

      <div class="insurance-grid">
        <a href="/hizmetler/arac-sigortlari" class="insurance-card">
          <img src="/icons/araç kasko.png" alt="Araç Sigortaları">
          <h3>Araç Sigortaları</h3>
        </a>
        <a href="/hizmetler/konut-isyeri" class="insurance-card">
          <img src="/icons/dask.png" alt="Konut ve İşyeri">
          <h3>Konut ve İşyeri</h3>
        </a>
        <a href="/hizmetler/saglik-hayat" class="insurance-card">
          <img src="/icons/tamamlayıcı_saglık.png" alt="Sağlık ve Hayat">
          <h3>Sağlık ve Hayat</h3>
        </a>
        <a href="/hizmetler/tarim-hayvancilik" class="insurance-card">
          <img src="/icons/ekasko.png" alt="Tarım ve Hayvancılık">
          <h3>Tarım ve Hayvancılık</h3>
        </a>
        <a href="/hizmetler/seyahat-ozel" class="insurance-card">
          <img src="/icons/seyahat_saglık.png" alt="Seyahat Sigortaları">
          <h3>Seyahat ve Özel</h3>
        </a>
        <a href="/hizmetler/muhendislik-insaat" class="insurance-card">
          <img src="/icons/imm.png" alt="Mühendislik Sigortaları">
          <h3>Mühendislik Sigortaları</h3>
        </a>
        <a href="/hizmetler/ticari-kurumsal" class="insurance-card">
          <img src="/icons/trafik_sigorta.png" alt="Ticari ve Kurumsal">
          <h3>Ticari ve Kurumsal</h3>
        </a>
      </div>

      <a href="/teklif-al" class="btn-view-all">Hemen Teklif Al</a>
    </div>
  </section>

  <!-- Why YILDIZ360 Section -->
  <section class="why-webpol">
    <div class="container">
      <h2>Neden YILDIZ360</h2>
      <p class="section-subtitle">Sigorta ihtiyaçlarınızda yanınızdayız, en uygun teklifi sizin için buluyoruz.</p>

      <div class="features-list-centered">
          <div class="feature-item">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
            </div>
            <div>
              <h3>Güvenilir Hizmet</h3>
              <p>20+ anlaşmalı sigorta şirketi ile sizin için en doğru sigorta çözümlerini sunuyoruz.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </div>
            <div>
              <h3>Hızlı ve Kolay İşlemler</h3>
              <p>Poliçe satın alma, yenileme ve hasar süreçlerini hızlı ve pratik şekilde yönetiyoruz.</p>
            </div>
          </div>

          <div class="feature-item">
            <div class="feature-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
            </div>
            <div>
              <h3>Uzman Kadro</h3>
              <p>Alanında deneyimli ekibimiz ile fiyat karşılaştırması yapıyor, en uygun poliçeyi buluyoruz.</p>
            </div>
          </div>
      </div>
    </div>
  </section>

  <!-- Insurance Security Section -->
  <section class="insurance-security">
    <div class="container">
      <h2>Sigorta Güvenceniz Yanınızda!</h2>
      <p class="section-subtitle">YILDIZ360 olarak trafik, kasko, konut, sağlık ve daha birçok branşta güvenilir sigorta çözümleri sunuyoruz. İhtiyaçlarınıza özel poliçeler ile sizi koruma altına alıyoruz.</p>

      <div class="security-grid">
        <div class="security-card">
          <div class="security-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg></div>
          <h3>Müşteri Memnuniyeti</h3>
          <p>%100 Müşteri Memnuniyeti Odaklı Hizmet</p>
        </div>

        <div class="security-card">
          <div class="security-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg></div>
          <h3>7/24 Destek</h3>
          <p>Her An Ulaşabileceğiniz Destek Hattı</p>
        </div>

        <div class="security-card">
          <div class="security-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></div>
          <h3>En Uygun Fiyat</h3>
          <p>Birden Fazla Şirketten Karşılaştırmalı Teklif Alın</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Testimonials Section -->
  <section class="testimonials">
    <div class="container">
      <h2>Müşterilerimizle Bağımızın Sırrı Güvendir.</h2>

      <div class="testimonials-wrapper">
        <div class="testimonial-card active">
          <p class="testimonial-text">Trafik sigortamı YILDIZ360 üzerinden yaptırdım. Hem hızlı hem de uygun fiyatlı. Kesinlikle tavsiye ederim!</p>
          <div class="testimonial-author">
            <div class="avatar-placeholder">HO</div>
            <div>
              <h4>Harun Oruç</h4>
              <p>Araç Sahibi</p>
            </div>
          </div>
        </div>

        <div class="testimonial-avatars">
          <div class="avatar-group">
            <div class="avatar-placeholder small">SY</div>
            <div class="avatar-placeholder small">ED</div>
            <div class="avatar-placeholder small">MK</div>
          </div>
        </div>
      </div>

      <div class="testimonial-nav">
        <button class="nav-btn" id="prev-testimonial">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M15 18l-6-6 6-6"/>
          </svg>
        </button>
        <button class="nav-btn" id="next-testimonial">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 18l6-6-6-6"/>
          </svg>
        </button>
      </div>
    </div>
  </section>

  <!-- Partner Companies Section -->
  <section class="partners">
    <div class="container">
      <h2>Anlaşmalı Sigorta Şirketleri</h2>
      <p class="section-subtitle">20+ sigorta şirketi ile çalışarak size en uygun teklifi sunuyoruz.</p>
      <div class="partners-grid">
        <div class="partner-badge">Anadolu Sigorta</div>
        <div class="partner-badge">Allianz Sigorta</div>
        <div class="partner-badge">Axa Sigorta</div>
        <div class="partner-badge">Mapfre Sigorta</div>
        <div class="partner-badge">Sompo Sigorta</div>
        <div class="partner-badge">HDI Sigorta</div>
        <div class="partner-badge">Zurich Sigorta</div>
        <div class="partner-badge">Generali Sigorta</div>
        <div class="partner-badge">Groupama Sigorta</div>
        <div class="partner-badge">Ray Sigorta</div>
        <div class="partner-badge">Doğa Sigorta</div>
        <div class="partner-badge">Quick Sigorta</div>
        <div class="partner-badge">Türk Nippon Sigorta</div>
        <div class="partner-badge">Koru Sigorta</div>
        <div class="partner-badge">Neova Sigorta</div>
        <div class="partner-badge">Bereket Sigorta</div>
        <div class="partner-badge">Ziraat Sigorta</div>
        <div class="partner-badge">Halk Sigorta</div>
        <div class="partner-badge">Türkiye Sigorta</div>
        <div class="partner-badge">Gulf Sigorta</div>
      </div>
      <a href="/anlasmali-sigorta-sirketleri" class="btn-outline" style="margin-top: 30px; display: inline-block;">Tümünü Gör</a>
    </div>
  </section>

  <!-- Statistics Section -->
  <section class="statistics">
    <div class="container">
      <div class="stats-card">
        <h2>Sayılarla YILDIZ360</h2>
        <p>Müşterilerimize kesintisiz bir sigorta süreci sunuyoruz.</p>

        <div class="stats-grid">
          <div class="stat-item">
            <h3>20+</h3>
            <p>Anlaşmalı<br>Sigorta Şirketi</p>
          </div>
          <div class="stat-item">
            <h3>7/24</h3>
            <p>Müşteri<br>Desteği</p>
          </div>
          <div class="stat-item">
            <h3>250+</h3>
            <p>Mutlu<br>Müşteri</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- FAQ Section -->
  <section class="faq">
    <div class="container">
      <div class="faq-layout">
        <div class="faq-intro">
          <h2>Sıkça Sorulan Sorular</h2>
          <p>Sigorta ile ilgili aklınıza takılan tüm sorulara ve en çok merak edilen konulara burada yanıt bulabilirsiniz. Poliçe süreçlerinden teminat detaylarına kadar tüm bilgilere kolayca ulaşabilirsiniz.</p>
          <a href="/sikca-sorulan-sorular" class="btn-primary">Tümünü Gör</a>
        </div>

        <div class="faq-list">
          <div class="faq-item">
            <button class="faq-question">
              Araç hasar kaydı sigortayı etkiler mi?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Evet, araç hasar kayıtları sigorta primlerini etkileyebilir.</p>
            </div>
          </div>

          <div class="faq-item">
            <button class="faq-question">
              Sigorta poliçesinde Muafiyet nedir?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Muafiyet, hasarın belirli bir tutarının sigortalı tarafından karşılanmasıdır.</p>
            </div>
          </div>

          <div class="faq-item">
            <button class="faq-question">
              İş yeri Sigortası neleri kapsar?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>İş yeri sigortası, işyerinizi yangın, hırsızlık ve doğal afetlere karşı korur.</p>
            </div>
          </div>

          <div class="faq-item">
            <button class="faq-question">
              Dask ve Konut Sigortası ayrımı nedir?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>DASK sadece deprem riskini kapsar, konut sigortası ise daha geniş kapsamlıdır.</p>
            </div>
          </div>

          <div class="faq-item">
            <button class="faq-question">
              Tamamlayıcı Sağlık Sigortasını (TSS) Kimler yaptırabilir?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>TSS'yi SGK veya özel sağlık sigortası olan herkes yaptırabilir.</p>
            </div>
          </div>

          <div class="faq-item">
            <button class="faq-question">
              Hangi durumlarda Tamamlayıcı Sağlık Sigortası (TSS) provizyon vermez?
              <span class="faq-icon">+</span>
            </button>
            <div class="faq-answer">
              <p>Önceden var olan hastalıklar ve bekleme süresi içindeki tedaviler kapsam dışıdır.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
`;
